var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const articleGrid = () => {
    const attachEventListeners = (section) => {
        section.addEventListener('click', (event) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const target = event.target;
            if (target.matches('[data-load-more]')) {
                const url = target.getAttribute('data-load-more');
                target.classList.add('article-grid__load-more-button--loading');
                try {
                    const response = yield fetch(url);
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = yield response.text();
                    const parser = new DOMParser();
                    const newDoc = parser.parseFromString(data, 'text/html');
                    const newArticles = newDoc.getElementById('article-grid__articles').innerHTML;
                    const articleGridInner = section.querySelector('.article-grid__inner');
                    if (articleGridInner) {
                        articleGridInner.innerHTML += newArticles;
                    }
                    (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.remove();
                    const nextPageButton = newDoc.querySelector('[data-load-more]');
                    if (nextPageButton) {
                        const buttonContainer = newDoc.querySelector('.article-grid__button-container');
                        if (buttonContainer) {
                            section.appendChild(buttonContainer);
                        }
                    }
                }
                catch (error) {
                    console.error('Error fetching more articles:', error);
                }
            }
        }));
    };
    // Attach event listeners to existing [data-article-grid] elements
    const articleGridSections = document.querySelectorAll('[data-article-grid]');
    articleGridSections.forEach(attachEventListeners);
    // Create a MutationObserver instance
    const observerSection = document.querySelector('.shopify-section--article-grid');
    const observerConfig = { attributes: true, childList: true, subtree: true };
    const observerCallback = () => {
        const articleGridSections = document.querySelectorAll('[data-article-grid]');
        articleGridSections.forEach(attachEventListeners);
    };
    const observer = new MutationObserver(observerCallback);
    // Start observing changes in the document's body
    if (observerSection) {
        observer.observe(observerSection, observerConfig);
    }
};
export { articleGrid };
